import { render, staticRenderFns } from "./arrowLeft.vue?vue&type=template&id=d97afcc0&"
import script from "./arrowLeft.vue?vue&type=script&lang=ts&"
export * from "./arrowLeft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports